declare global {
  interface Array<T> {
    shuffle(): T[];
  }
}

Array.prototype.shuffle = function <T>(this: T[]): T[] {
  for (let i = this.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const a = this[i] as T;
    this[i] = this[j] as T;
    this[j] = a;
  }
  return this;
};
